import { Copy } from 'components/Icon'
import { useCopyText } from 'providers/copy'
import { Box, BoxProps } from 'theme-ui'

export const CopyBtn = ({
  size,
  color,
  copyText,
  copyTextName = 'Text',
  sx,
}: {
  size?: number
  color?: string
  copyText?: string
  copyTextName?: string
  sx?: BoxProps['sx']
}) => {
  const { copy } = useCopyText()
  const handleClick = () => {
    if (copyText) {
      copy(copyText, copyTextName)
    }
  }
  if (!copyText) return null
  else
    return (
      <>
        <Box onClick={handleClick} sx={{ cursor: 'pointer', mt: -1, ...sx }}>
          <Copy size={size} color={color} />
        </Box>
      </>
    )
}
